import { type ICountry } from '@mahawi/eshop-common/src/types';
import { createSlice } from '@reduxjs/toolkit';

import {
  asyncStateInitial,
  finishLoading,
  requestFailedMatcher,
  resetLoadingOnRequestFailed,
  startLoading,
} from '../async-state';
import { type ICountriesState } from './types';

export const preloadedState: ICountriesState = {
  ...asyncStateInitial,
  countries: undefined,
};

const countriesSlice = createSlice({
  name: 'Countries',
  initialState: preloadedState,
  reducers: {
    countriesLoadAll(state) {
      startLoading(state);
      state.countries = undefined;
      state.updatedAt = undefined;
    },
    countriesLoadAllResponse: {
      reducer(state, action: { payload: { countries: ICountry[] } }) {
        state.countries = action.payload.countries;
        finishLoading(state);
      },
      prepare(countries: ICountry[]) {
        return { payload: { countries } };
      },
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      requestFailedMatcher('Countries'),
      resetLoadingOnRequestFailed,
    );
  },
});

export const { countriesLoadAll, countriesLoadAllResponse } =
  countriesSlice.actions;
export default countriesSlice.reducer;
